/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const kioskBannerSchema = z
	.object({
		id: z.uuid(),
		url: z.string().nullable(),
		media_type: z.string(),
		product_external_id: z.uuid().nullable(),
		duration: z.int(),
		order: z.int(),
	})
	.describe("Сериализатор баннера киоска.");
